export const billsChartSize = 6;

export const monthsRange = [3, 6, 12, 18];

export const billsByMonth = '18';
